import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Loader,
  Radio,
  RadioGroupField,
  TextField,
  Text,
  PasswordField,
  View,
  Icon,
  Alert,
  Card,
  Link,
} from "@aws-amplify/ui-react";
import "./Clienti.css";
import { checkClienteAPI, checkClienteNomeCognomeAPI, checkClienteTelefonoAPI, getClienteAPI, modifyClienteAPI } from "../../data/api";
import ClienteBozzaForm from "./ClienteForm";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { MdArrowBack, MdArrowDownward, MdArrowForward, MdArrowRight, MdArrowRightAlt, MdCancel } from "react-icons/md";
import { formConfig, formReferentiConfig } from "./config";
import ReferenteForm from "./ReferenteForm";
import { useRef } from "react";

const defaultForm = {
  Nome: "",
  Cognome: "",
  Telefono: "+39",
  Referenti: []
};

const ModifyClienteForm = (props) => {
  const [loading, setLoading] = useState(true);
  const [emptyState, setEmptyState] = useState(false);
  const [error, setError] = useState(false);
  const [loadingModify, setLoadingModify] = useState(false);
  const [errorModify, setErrorModify] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const idCliente = queryParams.get('id');
  const modifyReferentiRef = useRef(null);

  // modify ClienteBozza form data
  const [modifyClienteFormValuesSaved, setModifyClienteFormValuesSaved] = useState(defaultForm); // the data on the DB
  const [modifyClienteFormValuesLocal, setModifyClienteFormValuesLocal] = useState(() => { // the local draft
    const storage = localStorage.getItem('modifyClienteFormValues-'+idCliente);
    return storage ? JSON.parse(storage) : defaultForm;
  });

  const changeInputModifyClienteForm = (e) => {
    const { name, value } = e.target;
    const newValue = { ...modifyClienteFormValuesLocal };
    name.split('.').reduce((acc, key, idx, arr) => 
      acc[key] = idx === arr.length - 1 ? value : acc[key] || {}, newValue);
    setModifyClienteFormValuesLocal(newValue);
    localStorage.setItem('modifyClienteFormValues-'+idCliente, JSON.stringify(newValue));
  };

  const changeInputReferenti = (e, index) => {
    const { name, value } = e.target;
    const newValue = { ...modifyClienteFormValuesLocal.Referenti[index] };
    name.split('.').reduce((acc, key, idx, arr) => 
      acc[key] = idx === arr.length - 1 ? value : acc[key] || {}, newValue);

    const newReferenti = [...modifyClienteFormValuesLocal.Referenti];
    newReferenti[index] = newValue;
    const newFormValue = {...modifyClienteFormValuesLocal, Referenti: newReferenti}
    setModifyClienteFormValuesLocal(newFormValue);
    localStorage.setItem('modifyClienteFormValues-'+idCliente, JSON.stringify(newFormValue));
  };
  
  const getCliente = async (id) => {    
    try{
      setLoading(true);
      setEmptyState(false);
      setError(false);
      const clienteResponse = await getClienteAPI(id);
      setModifyClienteFormValuesSaved(clienteResponse)
      if(localStorage.getItem('modifyClienteFormValues-'+idCliente) === null){
        setModifyClienteFormValuesLocal(clienteResponse)
      }
      setLoading(false);
    } catch (e) {
      if(e.statusCode === 404){
        setEmptyState(true);
      } else {
        console.log('Loading cliente '+id+' failed ', e);
        setError(true);
      }
      setLoading(false);
    }
  }

  const resetModifyClienteForm = () => {
    setModifyClienteFormValuesLocal(defaultForm);
    localStorage.removeItem('modifyClienteFormValues-'+idCliente);
  }

  const modifyClienteBozza = async () => {
    try{
      setLoadingModify(true);
      setErrorModify(false);
      await modifyClienteAPI({...modifyClienteFormValuesLocal});
      setLoadingModify(false);
      navigate('/clienti/detail?id='+idCliente)
      resetModifyClienteForm();
    } catch (e) {
      console.log('Modify Cliente failed ', e);
      setErrorModify(true);
      setLoadingModify(false);
    }
  };
  
  useEffect(() => {
    getCliente(idCliente);
  }, []);

  // check if duplicate
  const [showAlertDuplicate, setShowAlertDuplicate] = useState(false);
  const checkClienteDuplicato = async () => {
    const nome = modifyClienteFormValuesLocal['Nome'];
    const cognome = modifyClienteFormValuesLocal['Cognome'];
    const telefono = modifyClienteFormValuesLocal['Telefono'];
    if(nome !== '' && cognome !== '' && telefono !== '' && nome !== null && cognome !== null && telefono !== null){
      try{
        const check = await checkClienteAPI(nome, cognome, telefono, idCliente);
        if(check.exists){
          setShowAlertDuplicate(true);
        } else {
          setShowAlertDuplicate(false);
        }
      } catch (e) {
        console.log('Check cliente failed ', e);
        setShowAlertDuplicate(false);
      }
    } else {
      setShowAlertDuplicate(false);
    }
  }

  // check if nome cognome is duplicate
  const [showAlertNomeCognomeDuplicate, setShowAlertNomeCognomeDuplicate] = useState(false);
  const checkClienteNomeCognomeDuplicato = async () => {
    const nome = modifyClienteFormValuesLocal['Nome'];
    const cognome = modifyClienteFormValuesLocal['Cognome'];
    if(nome !== '' && cognome !== '' && nome !== null && cognome !== null) {
      try{
        const check = await checkClienteNomeCognomeAPI(nome, cognome, idCliente);
        if(check.exists){
          setShowAlertNomeCognomeDuplicate(true);
        } else {
          setShowAlertNomeCognomeDuplicate(false);
        }
      } catch (e) {
        console.log('Check Cliente nome cognome failed ', e);
        setShowAlertNomeCognomeDuplicate(false);
      }
    } else {
      setShowAlertNomeCognomeDuplicate(false);
    }
  }

  const [showAlertTelefonoDuplicate, setShowAlertTelefonoDuplicate] = useState(false);
  const checkClienteTelefonoDuplicato = async () => {
    const telefono = modifyClienteFormValuesLocal['Telefono'];
    if(telefono !== '' && telefono !== null) {
      try{
        const check = await checkClienteTelefonoAPI(telefono, idCliente);
        if(check.exists){
          setShowAlertTelefonoDuplicate(true);
        } else {
          setShowAlertTelefonoDuplicate(false);
        }
      } catch (e) {
        console.log('Check Cliente telefono failed ', e);
        setShowAlertTelefonoDuplicate(false);
      }
    } else {
      setShowAlertTelefonoDuplicate(false);
    }
  }

  const onBlurField = (e) => {
    if(e.target.name === 'Nome' || e.target.name === 'Cognome' || e.target.name === 'Telefono'){
      checkClienteDuplicato()
    }
    if(e.target.name === 'Nome' || e.target.name === 'Cognome'){
      checkClienteNomeCognomeDuplicato()
    }
    if(e.target.name === 'Telefono'){
      checkClienteTelefonoDuplicato()
    }
  }

  useEffect(() => {
    checkClienteDuplicato()
    checkClienteNomeCognomeDuplicato()
    checkClienteTelefonoDuplicato()
  }, []);


  const [isSchedaButtonDisabled, setIsSchedaButtonDisabled] = useState(true);
  useEffect(() => {
    const isAnyFieldEmpty = formConfig.sections
      .flatMap(section => section.fields)
      .filter(field => (field.isRequired ?? false))
      .map(field => field.name)
      .some(field => !modifyClienteFormValuesLocal[field] 
        || modifyClienteFormValuesLocal[field] === '' 
        || JSON.stringify(modifyClienteFormValuesLocal[field]) === '{}');
    setIsSchedaButtonDisabled(isAnyFieldEmpty);
  }, [modifyClienteFormValuesLocal]);

  return (
    <View maxWidth="100%" padding="0rem" minHeight="100vh">
      <View
        backgroundColor="var(--amplify-colors-white)"
        borderRadius="6px"
        maxWidth="100%"
        padding="1rem"
      >
        <View marginBottom="10px">
            <NavLink to={'/clienti/detail?id='+idCliente} className="amplify-link"><Icon as={MdArrowBack}></Icon> Torna indietro</NavLink>
        </View>
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px'
        }}>
            <h2>Modifica cliente</h2>
            <View>
             {loadingModify ? <Loader/> : <>
              <Button
                onClick={()=>modifyClienteBozza()}
                variation="primary"
                disabled={loading || loadingModify || isSchedaButtonDisabled || showAlertDuplicate || ((modifyClienteFormValuesLocal.Disabilita === 'Si') && (!(modifyClienteFormValuesLocal.Documenti?.find(d => d.Tipo === '104') !== undefined)))}
                width={"fit-content"}
                alignSelf={"right"}
              >
                { "Salva modifiche"}
              </Button>
              { errorModify ? <View><span style={{color: "red", marginLeft: "auto"}}>Errore nella modifica!</span></View> : ""}
              </>}
            </View>
        </div>
      {
        loading ? <Loader/> : 
        error ? <Alert variation="error">Errore nel caricamento dei dati</Alert> : 
        emptyState ? <Alert variation="info">Cliente non trovato</Alert> :
        <>
          <Flex as="form" direction="column" onSubmit={(e) => {e.preventDefault(); modifyClienteBozza();}}>
              {showAlertDuplicate && <Alert variation="error">Attenzione: esiste già un cliente con questa anagrafica di base. Controllare la presenza di eventuali duplicati già inseriti.</Alert>}
              {(modifyClienteFormValuesLocal.Disabilita === 'Si') && (!(modifyClienteFormValuesLocal.Documenti?.find(d => d.Tipo === '104') !== undefined)) && <Alert variation="error">Attenzione: in caso di cliente con disabilità, è necessario inserire i documenti per la 104.</Alert>}
              {JSON.stringify(modifyClienteFormValuesLocal) !== JSON.stringify(modifyClienteFormValuesSaved) && <Alert variation="warning">Attenzione: ci sono dati modificati non salvati.</Alert>}
              {showAlertNomeCognomeDuplicate && !showAlertDuplicate && <Alert variation="warning">Attenzione: esiste già un cliente con lo stesso nome e cognome. Controllare la presenza di eventuali duplicati già inseriti.</Alert>}
            {showAlertTelefonoDuplicate && !showAlertDuplicate && <Alert variation="warning">Attenzione: esiste già un cliente con lo stesso numero di telefono. Controllare la presenza di eventuali duplicati già inseriti.</Alert>}
              <Link
                onClick={() => modifyReferentiRef?.current?.scrollIntoView({ behavior: "smooth" })}
              >Vai ai referenti <Icon as={MdArrowForward}></Icon></Link>
              <ClienteBozzaForm
                  value={modifyClienteFormValuesLocal}
                  savedValue={modifyClienteFormValuesSaved}
                  onChange={changeInputModifyClienteForm}
                  onBlur={onBlurField}>
              </ClienteBozzaForm>
              <hr/>
              <View ref={modifyReferentiRef}><h2>Modifica referenti</h2></View>
                {
                  (modifyClienteFormValuesLocal.Referenti)?.map((r, index) => {
                    return <Card variation="elevated" marginBottom="20px">
                    <View columnSpan={[1,1,1,4]} textAlign="right">
                      <Icon 
                        as={MdCancel} 
                        color="red" 
                        marginLeft="5px" 
                        marginBottom="2px" 
                        style={{cursor: "pointer"}}  
                        onClick={ () => changeInputModifyClienteForm({target: {name: 'Referenti', value: 
                          (modifyClienteFormValuesLocal['Referenti'] ?? []).filter((r, i) => index !== i)
                        }}) }
                      />
                    </View>
                      <View columnSpan={[1,1,1,4]}>
                        <Text marginBottom="5px"><h4>Referente #{index+1}</h4></Text>
                      </View>
                      <ReferenteForm
                        className={"Referenti-"+index}
                        value={modifyClienteFormValuesLocal.Referenti?.[index] ?? defaultForm}
                        savedValue={modifyClienteFormValuesSaved.Referenti?.[index] ?? defaultForm}
                        onChange={(e) => changeInputReferenti(e, index)}
                        onBlur={onBlurField}>
                      </ReferenteForm>
                    </Card>
                    }
                  )
                }
                <Button 
                  className="add-Referenti"
                  onClick={ () => changeInputModifyClienteForm({target: {name: 'Referenti', value: [...(modifyClienteFormValuesLocal['Referenti'] ?? []), {}]}}) }
                  width={"fit-content"}
                >Aggiungi referente</Button>
            <View textAlign={"right"}>
             {loadingModify ? <Loader/> : <>
              <Button
                type="submit"
                variation="primary"
                disabled={loading || loadingModify || isSchedaButtonDisabled || showAlertDuplicate || ((modifyClienteFormValuesLocal.Disabilita === 'Si') && (!(modifyClienteFormValuesLocal.Documenti?.find(d => d.Tipo === '104') !== undefined)))}
                width={"fit-content"}
                alignSelf={"right"}
              >
                { "Salva modifiche"}
              </Button></>}
            </View>
          { errorModify ? <span style={{color: "red", marginLeft: "auto"}}>Errore nella modifica!</span> : ""}
          </Flex>
        </>
      }
      </View>
    </View>
  );
};

export default ModifyClienteForm;
